import { useRef } from 'react';
import isAndroid from '../utils/isAndroid';

export default function useIsAndroid() {
  const isAndroidRef = useRef<boolean | null>(null);

  if (isAndroidRef.current === null && typeof window !== 'undefined') {
    isAndroidRef.current = isAndroid();
  }

  return isAndroidRef.current ?? false;
}
